import React from 'react';
import styles from './icons.module.scss';
import { assetsPath, KEY } from 'Data/constants';
import { useIntl } from 'react-intl';
import clsx from 'clsx';

const Icons = () => {
  const { formatMessage } = useIntl();

  const iconData = [
    {
      href: 'https://mypharmacy.shoppersdrugmart.ca/en/refill',
      src: `${assetsPath}/site-icons/2020-site-icons/ico-prescriptions-m.svg`,
      text: formatMessage({ id: 'refills' }),
      className: styles.refills,
      width: 17.082,
      height: 20.578,
    },
    {
      href: 'https://stores.shoppersdrugmart.ca',
      src: `${assetsPath}/site-icons/2020-site-icons/ico-stores-m.svg`,
      text: formatMessage({ id: 'stores' }),
      className: styles.stores,
      width: 14,
      height: 16,
    },
    {
      href: 'https://www1.shoppersdrugmart.ca/en/flyer',
      src: `${assetsPath}/site-icons/2020-site-icons/ico-flyer-m.svg`,
      text: formatMessage({ id: 'flyer' }),
      className: styles.flyer,
      width: 16,
      height: 16,
    },
  ];

  return (
    <>
      {iconData.map(({ href, src, text, className, width, height }) => (
        <li
          role="presentation"
          key={text}
          className={styles.navItemIcons}
          onKeyDown={(event) => {
            if (event.key === KEY.ENTER) ((event.target as HTMLElement).children?.[0] as HTMLElement).click?.();
          }}
        >
          <a href={href} target="_blank" rel="noopener noreferrer" className={clsx(styles.icon, className)} key={href}>
            {/* WARN: using a NextJS image here is known as a possible cause of a bug in dev (https://gitlab.lblw.ca/sdm/sdm-frontshop/-/merge_requests/73) */}
            <img src={src} alt={text} />
            <span>{text}</span>
          </a>
        </li>
      ))}
    </>
  );
};

export default Icons;
